import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    FaBars,
    FaHome,
    FaUser,
    FaMoneyBillWave,
    FaChevronDown,
    FaChevronRight,
    FaUserGraduate,
    FaUserTie,
    FaFileInvoice,
    FaReceipt,
    FaBuilding,
    FaUniversity,
    FaMoneyCheck,
    FaFileInvoiceDollar,
    FaTimes, 
    FaMoneyCheckAlt 
} from "react-icons/fa";
import "../css/Sidebar.css";

const Sidebar = ({ isCollapsed, isMobileOpen, toggleSidebar }) => {
    // Track dropdown menu states
    const [openDropdown, setOpenDropdown] = useState({
        collegeFees: false,
        hostelFees: false,
        tuitionFees: false
    });
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();
    
    // Check if screen is mobile size
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    // Toggle dropdown menus - close other dropdowns when one is opened
    const toggleDropdown = (menu) => {
        if (isCollapsed && !isMobile) {
            toggleSidebar(); // Expand sidebar first
            setTimeout(() => {
                setOpenDropdown({
                    collegeFees: false,
                    hostelFees: false,
                    tuitionFees: false,
                    [menu]: !openDropdown[menu]
                });
            }, 300);
        } else {
            setOpenDropdown({
                collegeFees: false,
                hostelFees: false,
                tuitionFees: false,
                [menu]: !openDropdown[menu]
            });
        }
    };

    // Handle navigation and close sidebar on mobile
    const handleNavigation = (path) => {
        if (isMobile && isMobileOpen) {
            toggleSidebar(); // Close the sidebar
        }
        navigate(path);
    };

    // Custom Link component that will close sidebar on mobile
    const NavLink = ({ to, children }) => (
        <div onClick={() => handleNavigation(to)} className="sidebar-link-content">
            {children}
        </div>
    );

    return (
        <>
            {/* Mobile overlay */}
            {isMobile && isMobileOpen && (
                <div className="sidebar-overlay" onClick={toggleSidebar}></div>
            )}
            
            <div className={`sidebar ${isCollapsed ? "collapsed" : ""} ${isMobile && isMobileOpen ? "mobile-open" : ""}`}>
                <div className="sidebar-header">
                    <div className="logo-container">
                        {!isCollapsed && <h3>MCAM, Admin</h3>}
                    </div>
                    <button className="toggle-btn" onClick={toggleSidebar}>
                        {isMobile && isMobileOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                <div className="sidebar-content">
                    <ul className="sidebar-menu">
                        <li className="sidebar-item">
                            <Link to="/dashboard" className="sidebar-link" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                <span className="sidebar-icon"><FaHome /></span>
                                {(!isCollapsed || (isMobile && isMobileOpen)) && <span className="sidebar-text">Dashboard</span>}
                            </Link>
                        </li>
                        
                        {/* College Fees dropdown */}
                        <li className="sidebar-item">
                            <div
                                className={`sidebar-link ${openDropdown.collegeFees ? 'active' : ''}`}
                                onClick={() => toggleDropdown('collegeFees')}
                            >
                                <span className="sidebar-icon"><FaUniversity /></span>
                                {(!isCollapsed || (isMobile && isMobileOpen)) && (
                                    <>
                                        <span className="sidebar-text">College Fees</span>
                                        <span className="sidebar-arrow">
                                            {openDropdown.collegeFees ? <FaChevronDown /> : <FaChevronRight />}
                                        </span>
                                    </>
                                )}
                            </div>
                            {(!isCollapsed || (isMobile && isMobileOpen)) && openDropdown.collegeFees && (
                                <ul className="sidebar-dropdown">
                                    <li>
                                        <Link to="/college-fees-bill" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaFileInvoice /></span>
                                            <span className="sidebar-text">Generate Bill</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/college-payment-records" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaReceipt /></span>
                                            <span className="sidebar-text">Payment Records</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/college-account-update" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaMoneyCheckAlt /></span>
                                            <span className="sidebar-text">Account Update</span>
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li>

                        {/* Hostel Fees dropdown */}
                        <li className="sidebar-item">
                            <div
                                className={`sidebar-link ${openDropdown.hostelFees ? 'active' : ''}`}
                                onClick={() => toggleDropdown('hostelFees')}
                            >
                                <span className="sidebar-icon"><FaBuilding /></span>
                                {(!isCollapsed || (isMobile && isMobileOpen)) && (
                                    <>
                                        <span className="sidebar-text">Hostel Fees</span>
                                        <span className="sidebar-arrow">
                                            {openDropdown.hostelFees ? <FaChevronDown /> : <FaChevronRight />}
                                        </span>
                                    </>
                                )}
                            </div>
                            {(!isCollapsed || (isMobile && isMobileOpen)) && openDropdown.hostelFees && (
                                <ul className="sidebar-dropdown">
                                    <li>
                                        <Link to="/hostel/generate-bill" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaFileInvoice /></span>
                                            <span className="sidebar-text">Generate Bill</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/hostel/payment-records" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaReceipt /></span>
                                            <span className="sidebar-text">Payment Records</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/hostel/account-update" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaMoneyCheckAlt /></span>
                                            <span className="sidebar-text">Account Update</span>
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li>

                        {/* Tuition Fees dropdown */}
                        <li className="sidebar-item">
                            <div
                                className={`sidebar-link ${openDropdown.tuitionFees ? 'active' : ''}`}
                                onClick={() => toggleDropdown('tuitionFees')}
                            >
                                <span className="sidebar-icon"><FaFileInvoiceDollar /></span>
                                {(!isCollapsed || (isMobile && isMobileOpen)) && (
                                    <>
                                        <span className="sidebar-text">Tuition Fees</span>
                                        <span className="sidebar-arrow">
                                            {openDropdown.tuitionFees ? <FaChevronDown /> : <FaChevronRight />}
                                        </span>
                                    </>
                                )}
                            </div>
                            {(!isCollapsed || (isMobile && isMobileOpen)) && openDropdown.tuitionFees && (
                                <ul className="sidebar-dropdown">
                                    <li>
                                        <Link to="/tuition/generate-bill" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaUserGraduate /></span>
                                            <span className="sidebar-text">Generate Bill</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/tuition/payment-records" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaUserTie /></span>
                                            <span className="sidebar-text">Payment Records</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/tuition/account-update" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                            <span className="sidebar-icon"><FaMoneyCheckAlt /></span>
                                            <span className="sidebar-text">Account Update</span>
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li>
                        {/* student add */}
                        <li className="sidebar-item">
                            <Link to="/students" className="sidebar-link" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                <span className="sidebar-icon"><FaUser /></span>
                                {(!isCollapsed || (isMobile && isMobileOpen)) && <span className="sidebar-text">Add Students</span>}
                            </Link>
                        </li>
                        <li className="sidebar-item">
                            <Link to="/view-students" className="sidebar-link" onClick={() => isMobile && isMobileOpen && toggleSidebar()}>
                                <span className="sidebar-icon"><FaUserGraduate /></span>
                                {(!isCollapsed || (isMobile && isMobileOpen)) && <span className="sidebar-text">View Students</span>}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Sidebar;